/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LoadMore from 'vux/src/components/load-more';
import Alert from 'vux/src/components/alert';
import Group from 'vux/src/components/group';
import Cell from 'vux/src/components/cell';
import XButton from 'vux/src/components/x-button';
import XInput from 'vux/src/components/x-input';
import XDialog from 'vux/src/components/x-dialog';
import Popup from 'vux/src/components/popup';
import PopupHeader from 'vux/src/components/popup-header';
import PopupPicker from 'vux/src/components/popup-picker';
import Tab from 'vux/src/components/tab/tab';
import TabItem from 'vux/src/components/tab/tab-item';
import InlineXNumber from 'vux/src/components/inline-x-number';
import TransferDom from 'vux/src/directives/transfer-dom';
import Empty from '@/components/Empty/Empty';
import { Dialog, Toast } from 'vant';
export default {
  name: 'MealOrdering',
  directives: {
    TransferDom: TransferDom
  },
  components: {
    XInput: XInput,
    Group: Group,
    XButton: XButton,
    Cell: Cell,
    Tab: Tab,
    Alert: Alert,
    Popup: Popup,
    PopupHeader: PopupHeader,
    InlineXNumber: InlineXNumber,
    PopupPicker: PopupPicker,
    TabItem: TabItem,
    Empty: Empty,
    LoadMore: LoadMore,
    XDialog: XDialog
  },
  data: function data() {
    return {
      showScrollBox: false,
      //图片显示
      zhanshiPhoto: '',
      //展示照片
      Tebactive: 'a',
      isMsgShow: false,
      //是否显示详情
      mySearch: '',
      weekTitle: [{
        title: '一',
        value: '1'
      }, {
        title: '二',
        value: '2'
      }, {
        title: '三',
        value: '3'
      }, {
        title: '四',
        value: '4'
      }, {
        title: '五',
        value: '5'
      }, {
        title: '六',
        value: '6'
      }, {
        title: '日',
        value: '7'
      }],
      //周标题数组
      weekList: [],
      //周数组
      timestamp: 0,
      //当前时间戳
      year: '',
      month: '',
      currDate: '',
      //选中的某天
      spareCol: '',
      //支付方式
      today: '',
      //今天
      nowTime: '',
      //当前时间
      merchantId: null,
      //商户编号
      placeId: '',
      //场所编号
      mealTypeList: [],
      mealId: '',
      //选择的餐别ID
      curIndex: 0,
      //默认选中的餐别
      goods: [],
      emptyShow: false,
      //数据是否为空
      emptyTip: '暂无菜品',
      listHeight: [],
      //每个菜单将要滑动的height
      scrollY: 0,
      alertFlag: false,
      showCart: false,
      remark: '',
      meals: [],
      //购物车订餐选择的餐别数组
      mealList: [],
      //购物车订餐选择的菜品数组
      foodOrder: 0,
      totalNum: 0,
      //预订总份数
      totalPrice: 0,
      //预订总价钱
      rightHeight: '',
      orderDays: [],
      cancelFlag: '',
      windowList: [[{
        name: '',
        value: ''
      }]],
      merchantName: null,
      tempMerchantId: [],
      tebList: [],
      //套餐标签
      foodMsgList: [],
      //套餐详情标签
      foodMsgName: '',
      //套餐名字
      limitNum: 0,
      //单餐限制
      dheight: '',
      placeName: '',
      //餐厅名称
      windowName: '',
      //窗口名称
      iftoday: 1,
      //是否开启当日不可预订 0：未开启 1：开启
      spareCol7: 1,
      //是否当天可预定 0：可预订  1：不可预定
      Bookable: 0,
      //是否可预定
      isfirst: 0,
      tie: '',
      xi: 0 //  currentIndex: 0, //当前菜类

    };
  },
  computed: {
    // 选中的菜品索引
    currentIndex: function currentIndex() {
      console.log('this.listHeight', this.listHeight);

      for (var i = 0; i < this.listHeight.length; i++) {
        var height1 = this.listHeight[i];
        var height2 = this.listHeight[i + 1];
        console.log('height1', height1);
        console.log('height2', height2);
        console.log('this.scrollY', this.scrollY); // 下一个块没有高度 或者 现在的高度 高于当前模块 并且小于 下一模块

        if (!height2 || this.scrollY >= height1 && this.scrollY < height2) {
          console.log('in', i);
          return i;
        }
      }

      console.log('in zero');
      return 0;
    }
  },
  watch: {
    showCart: function showCart() {
      document.body.classList;

      if (this.showCart) {
        if (!document.body.classList.contains('modal-open')) {
          document.body.classList.add('modal-open');
        }
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  },
  methods: {
    //添加菜品至购物车的动画效果 foodId
    animation: function animation() {// TODO: 添加到购物车动画
      // let shoppingCart =document.querySelector('#shoppingCart') //  目标对象 终点的坐标
      // let itemCartObj =document.querySelector('#start' + foodId)// 起点对象  获取起点坐标
      // let flyHtml = "<div id='flyItem' class='fly-item'><img src='../../assets/goods.png' alt='' /></img>" // 自定义fly对象
      // let flyer = $(flyHtml)
      // flyer.fly({
      //   start: {
      //     left: itemCartObj.offsetLeft,
      //     top: itemCartObj.offsetTop,
      //   },
      //   end: {
      //     top: shoppingCart.offsetTop,
      //     left: shoppingCart.offsetLeft,
      //     width: 0,
      //     height: 0,
      //   },
      //   onEnd: function () {
      //     flyer.remove() // 结束移除飞行对象
      //   },
      // })
    },
    //跳转共享订单页面
    goShare: function goShare() {
      var _this = this;

      this.$api.Meal.getShareList({
        pageIndex: this.curPage,
        pageSize: this.pageNum,
        search: {
          startDate: this.startDate,
          mealState: ['6'],
          endDate: this.endDate
        }
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);

          _this.finished = true;
        } else {
          if (data.records && data.records.length > 0) {
            _this.$router.push({
              path: '/OrderShare'
            });
          } else {
            Toast('糟糕，还没有人共享订单，请稍后再来哦');
          }
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    // 点击图片
    imChlick: function imChlick(val) {
      if (!val) return;
      this.zhanshiPhoto = val;
      this.showScrollBox = true;
    },
    // 点击套餐详情
    getMsgTxt: function getMsgTxt(id, val, name) {
      if (val) {
        this.isMsgShow = true;
        this.foodMsgList = val;
        this.foodMsgName = name;
      }
    },

    /**
     * @function点击左侧菜类
     *      wzx
     *   2019.05.09
     **/
    selectMenu: function selectMenu(index) {
      // console.log(index)
      // if (!event._constructed) {
      //   //避免点击事件发生两次
      //   return
      // }
      // this.xi = index
      // this.xis = true
      this.$refs.foodsWrapper.scrollTo({
        top: this.listHeight[index],
        behavior: 'smooth'
      });
    },
    ha: function ha(index) {
      this.scrollY = this.listHeight[index];
    },

    /**
     * @function获取右侧内容高度
     *      wzx
     *   2019.05.09
     **/
    _calculateHeight: function _calculateHeight() {
      this.scrollY = 0;
      this.listHeight = [];
      var foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');
      console.log('foodList:', foodList.length);
      var height = 0;
      this.listHeight.push(height);

      for (var i = 0; i < foodList.length; i++) {
        var item = foodList[i];
        height += item.clientHeight; //元素内容及其边框所占据的空间大小

        this.listHeight.push(height); //将每一个  高度存起来
      }

      this.$refs.foodsul.style.transform = 'translate(0,0) scale(1) translateZ(0px)';
    },

    /**
     * @function设置右侧内容高度
     *      wzx
     *   2019.05.09
     **/
    _initScroll: function _initScroll() {
      var _this2 = this;

      var foodsWrapperDom = this.$refs.foodsWrapper;

      if (foodsWrapperDom) {
        var timer;
        foodsWrapperDom.addEventListener('scroll', function () {
          if (timer) {
            clearTimeout(timer);
          }

          timer = setTimeout(function () {
            _this2.scrollY = foodsWrapperDom.scrollTop;
          }, 100);
        });
      }
    },

    /**
     * @function获取当前周数组
     *      wzx
     *   2019.05.05
     **/
    getWeekList: function getWeekList(value) {
      this.weekList = [];
      var d = new Date(value).getDay(); //必须为value的日期

      var newWeekTitle = this.weekTitle.slice(d - 1);
      newWeekTitle.push.apply(newWeekTitle, _toConsumableArray(this.weekTitle.slice(0, d - 1)));
      this.weekTitle = newWeekTitle;

      for (var i = 0; i < 7; i++) {
        var curWeek = value + i * 24 * 3600 * 1000; //获取当前周几的时间戳

        this.weekList.push({
          day: this.$utils.DateUtils.formatTimeStamp(curWeek),
          week: this.$utils.DateUtils.getWeekTimeStamp(curWeek)
        }); //根据周几的时间戳返回周几的日期
      }
    },

    /**
     * @function对象数组排序
     *      wzx
     *   2019.05.06
     **/
    compare: function compare(property) {
      return function (obj1, obj2) {
        var value1 = obj1[property];
        var value2 = obj2[property];
        return value1 - value2; // 升序
      };
    },

    /**
     * @function查看购物车
     *      wzx
     *   2019.05.09
     **/
    cartClick: function cartClick() {
      this.showCart = true;
    },

    /**
     * @function清空购物车
     *      wzx
     *   2019.05.09
     **/
    emptyClick: function emptyClick() {
      this.meals = [];
      this.mealList = [];
      this.totalPrice = 0;
      this.totalNum = 0;
      this.$store.dispatch('actionFoodList', []);
    },
    // addToShopCart(event, food) {
    //   const tableware = this.mealList.filter((meal) => meal.foodName === '餐具')
    //   if (food.name !== '餐具' && tableware.length === 0) {
    //     const result = this.goods.map(item => item.meals.find(meal => meal.foodName === '餐具'))
    //     const resultData = result.filter(x => x !== undefined);
    //     this.addCart(event, resultData[0])
    //     this.addCart(event, food)
    //   } else {
    //     this.addCart(event, food)
    //   }
    // },

    /**
     * @function添加到购物车功能
     *      wzx
     *   2019.05.05
     **/
    addToShopCart: function addToShopCart(event, food) {
      //开启当日不可预订功能（iftoday：1）并且该餐别已设置不可当日预定（spareCol7：1）
      if (this.iftoday && this.spareCol7 == 1) return Toast('当前餐别不可当日预订');

      if (this.totalNum >= this.limitNum && this.limitNum != 0) {
        Toast('已过单餐限制份数');
        return;
      }

      if (food.foodNum - food.foodUse === 0 || food.foodNum - food.foodUse < 0) {
        Toast('此菜份数已预订完！');
        return;
      } //未开启当日不可预定，超时 解决了 预定餐超时再点击别的餐别导致不在提示


      if (this.Bookable == 0) {
        Toast('已过' + food.mealName + '时间，不可预订！');
        return;
      } // TODO: 添加到购物车动画
      // let shoppingCart = $('#shoppingCart').offset() //  目标对象 飞到的终点的坐标
      // let itemCartObj = $('#start' + food.foodId).offset() // 起点对象  获取起点坐标
      // let flyHtml = "<div id='flyItem' class='fly-item'><img src='../../assets/goods.png' alt='' /></img>" // 自定义fly对象
      // let flyer = $(flyHtml)
      // flyer.fly({
      //   start: {
      //     left: itemCartObj.left,
      //     top: itemCartObj.top,
      //   },
      //   end: {
      //     top: shoppingCart.top,
      //     left: shoppingCart.left,
      //     width: 0,
      //     height: 0,
      //   },
      //   onEnd: function () {
      //     flyer.remove() // 结束移除飞行对象
      //   },
      // })


      this.meals.push({
        mealId: food.mealId,
        mealName: food.mealName,
        orderEnd: food.orderEnd
      });
      var hash = {};
      /*es6数组去重*/

      var newArr = this.meals.reduceRight(function (item, next) {
        hash[next.mealId] ? '' : hash[next.mealId] = true && item.push(next);
        return item;
      }, []);
      this.meals = newArr.sort(this.compare('mealId'));

      if (this.mealList.length === 0) {
        this.mealList.push({
          mealId: food.mealId,
          mealName: food.mealName,
          foodId: food.foodId,
          foodName: food.foodName,
          foodNum: food.foodNum,
          foodUse: food.foodUse,
          foodPhoto: food.foodPhoto,
          foodPrice: food.foodPrice,
          placeId: food.placeId,
          merchantId: food.merchantId,
          operate: food.operate,
          orderEnd: food.orderEnd,
          foodType: food.foodType,
          foodOrder: 1
        });
      } else {
        var j;
        var list = this.mealList.filter(function (meal, indx) {
          if (meal.foodId === food.foodId && meal.mealId === food.mealId) {
            j = indx;
            return true;
          } else {
            return false;
          }
        });

        if (list.length > 0) {
          this.$set(this.mealList[j], 'foodOrder', this.mealList[j].foodOrder + 1);
        } else {
          this.mealList.push(food);
          this.$set(this.mealList[this.mealList.length - 1], 'foodOrder', 1);
        }
      }

      this.totalPrice = 0;
      this.totalNum = 0;
      var totalPrice = 0;

      var _iterator = _createForOfIteratorHelper(this.mealList),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          totalPrice += parseFloat((item.foodPrice * item.foodOrder).toFixed(2));
          this.totalNum += item.foodOrder;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.totalPrice = Math.round(totalPrice * 100) / 100;
    },

    /**
     * @function订单份数变化
     *      wzx
     *   2019.05.09
     **/
    changeNum: function changeNum(val, idx, food) {
      if (food.foodOrder <= food.foodNum - food.foodUse) {
        this.totalPrice = 0;
        this.totalNum = 0;

        if (val === 0) {
          this.mealList.splice(idx, 1);
          var hash = {};
          /*es6数组去重*/

          var newArr = this.mealList.reduceRight(function (item, next) {
            hash[next.mealId] ? '' : hash[next.mealId] = true && item.push(next);
            return item;
          }, []);
          this.meals = newArr.sort(this.compare('mealId'));
          /*if(this.mealList.length == 0){
          this.meals = [];
          }*/
        }

        var totalPrice = 0;

        var _iterator2 = _createForOfIteratorHelper(this.mealList),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            totalPrice += parseFloat((item.foodPrice * item.foodOrder).toFixed(2));
            this.totalNum += item.foodOrder;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.totalPrice = Math.round(totalPrice * 100) / 100;
      } else {
        Toast('此菜份数已预订完！');
      }
    },

    /**
     * @function获取当前日期
     *      wzx
     *   2019.04.12
     **/
    getSysDate: function getSysDate() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.$utils.Tools.loadShow();

                _context.next = 3;
                return _this3.$api.Sys.getSystemDate(_this3.$params.mode).then(function (response) {
                  _this3.$utils.Tools.loadHide();

                  var code = response.code,
                      msg = response.msg,
                      data = response.data;

                  if (+code !== _this3.$code.success) {
                    Toast(msg);
                  } else {
                    _this3.today = data.sysDate.substring(0, 10);
                    _this3.timestamp = _this3.$utils.DateUtils.getTimeStamp(data.sysDate) * 1000;
                    _this3.year = data.sysDate.substring(0, 4);
                    _this3.month = data.sysDate.substring(5, 7);
                    _this3.nowTime = data.sysDate.substring(11, 16);

                    _this3.getWeekList(_this3.timestamp);

                    _this3.getMealDays(_this3.placeId);
                  }
                }).catch(function () {
                  _this3.$utils.Tools.httpError();
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @function获取当前日期下的菜品列表
     *      wzx
     *   2019.05.05
     **/
    dayClick: function dayClick(day) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.iftoday = _this4.$utils.DateUtils.twoTimeInterval(_this4.today, day.day) >= 24 ? 0 : 1;

                if (!(_this4.orderDays.indexOf(day.day) > -1)) {
                  _context2.next = 13;
                  break;
                }

                if (!(_this4.cancelFlag === '0' && _this4.currDate !== day.day)) {
                  _context2.next = 6;
                  break;
                }

                Toast('现场订餐只可选择当天！');
                _context2.next = 11;
                break;

              case 6:
                _this4.emptyClick();

                _this4.currDate = day.day;
                _context2.next = 10;
                return _this4.getMealTypeList(_this4.currDate, _this4.merchantId, _this4.placeId);

              case 10:
                _this4._initScroll();

              case 11:
                _context2.next = 14;
                break;

              case 13:
                Toast('预订时间外不可预订！');

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * @function获取搜索的菜品列表
     *      wzx
     *   2019.05.05
     **/
    goSearch: function goSearch() {
      this.getFoodList(this.currDate, this.mySearch, this.mealId, this.merchantId, this.placeId);
    },

    /**
     * @function清空搜索内容后获取当前的菜品列表
     *      wzx
     *   2019.05.05
     **/
    clearSearch: function clearSearch() {
      this.mySearch = '';
      this.$refs.searchInput.blur();
      this.goSearch();
    },

    /**
     * @function获取当前日期选择的餐别
     *      wzx
     *   2019.05.05
     **/
    onItemClick: function onItemClick(id, index, name, spareCol7, Bookable) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.mealName = name;
                _this5.placeName = name;
                _this5.mealId = id;
                _this5.curIndex = index;
                _this5.spareCol7 = spareCol7;
                _this5.Bookable = Bookable;
                _this5.listHeight = []; //每个菜单将要滑动的height

                _this5.scrollY = 0;
                _context3.next = 10;
                return _this5.getFoodList(_this5.currDate, _this5.mySearch, _this5.mealId, _this5.merchantId, _this5.placeId, _this5.Bookable);

              case 10:
                _this5._initScroll();

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getMealDays: function getMealDays(placeId) {
      var _this6 = this;

      this.$api.Meal.selectDayState({
        placeId: placeId
      }).then(function (response) {
        _this6.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this6.$code.success) {
          Toast(msg);
        } else {
          // data.splice(0,1)//lwt  ---修改  -- 当天不可以预定2020-06-30  --企业不需要这个
          _this6.orderDays = data;
          _this6.iftoday = _this6.$utils.DateUtils.twoTimeInterval(_this6.today, data[0]) >= 24 ? 0 : 1;

          if (data.length > 0) {
            _this6.currDate = data[0];

            _this6.getWindowsList();
          }
        }
      }).catch(function () {
        _this6.$utils.Tools.httpError();
      });
    },
    currentDate: function currentDate() {
      var d = new Date();
      var y = d.getFullYear(); // 年

      var m = d.getMonth() + 1; // 月份从0开始的

      var yesterday_d = d.getDate() - 1; //日

      var today_d = d.getDate(); //日

      var tomorrow_d = d.getDate() + 1; //日

      if (m < 10) {
        m = '0' + m;
      }

      if (yesterday_d < 10) {
        yesterday_d = '0' + yesterday_d;
      }

      if (today_d < 10) {
        today_d = '0' + today_d;
      }

      if (tomorrow_d < 10) {
        tomorrow_d = '0' + tomorrow_d;
      }

      var yesterday = y + '-' + m + '-' + yesterday_d;
      var today = y + '-' + m + '-' + today_d;
      var tomorrow = y + '-' + m + '-' + tomorrow_d;
      var dateList = [yesterday, today, tomorrow];
      return dateList;
    },

    /**
     * @function获取当前日期的餐别数组
     *      wzx
     *   2019.05.05
     **/
    getMealTypeList: function getMealTypeList(date, merchantId, placeId) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.$utils.Tools.loadShow();

                _this7.listHeight = [];
                _context4.next = 4;
                return _this7.$api.Meal.getMealTypeList({
                  date: date,
                  placeId: placeId
                }).then(function (response) {
                  _this7.$utils.Tools.loadHide();

                  var code = response.code,
                      msg = response.msg,
                      data = response.data;

                  if (+code !== _this7.$code.success) {
                    Toast(msg);
                  } else {
                    _this7.mealTypeList = data;
                    _this7.mealId = data[0].mealId;
                    _this7.limitNum = data[0].spareCol5;
                    _this7.spareCol7 = data[0].spareCol7;

                    var DateList = _this7.currentDate();

                    var today = DateList[1];
                    var tomorrow = DateList[2];

                    for (var i = 0; i < data.length; i++) {
                      // 判断是否当日不可预订（spareCol7=1表示当日不可预定）
                      if (data[i].spareCol7 == 1) {
                        //判断当前时间是否超过可预订截止时间
                        //  超过：当日不可定，第二天也不可定，第三天可定
                        if (_this7.nowTime > data[i].orderEnd) {
                          // 选择日期为当日(当日超时，不可定)
                          if (_this7.currDate == today) {
                            data[i].Bookable = 0;

                            if (_this7.isfirst == 0) {
                              _this7.Bookable = 0;
                            }

                            _this7.curIndex = 0;
                          } //  选择日期为明天(明天不可预定)


                          //  选择日期为明天(明天不可预定)
                          if (_this7.currDate == tomorrow) {
                            if (_this7.isfirst == 0) {
                              _this7.Bookable = 0;
                            }

                            data[i].Bookable = 0;
                            _this7.curIndex = 0;
                          } //第三天可以预定


                          //第三天可以预定
                          if (_this7.currDate != today && _this7.currDate != tomorrow) {
                            _this7.Bookable = 1;
                            data[i].Bookable = 1;
                            _this7.curIndex = 0;
                            _this7.mealId = data[0].mealId;
                            _this7.spareCol = data[0].spareCol1;
                            break;
                          }
                        } else if (_this7.nowTime < data[i].orderEnd) {
                          //未超时：当日不可定，明天可定
                          if (_this7.currDate == today) {
                            if (_this7.isfirst == 0) {
                              _this7.Bookable = 0;
                            }

                            data[i].Bookable = 0;
                            _this7.curIndex = 0;
                          } //  选择日期为明天(明天可预定)


                          //  选择日期为明天(明天可预定)
                          if (_this7.currDate == tomorrow) {
                            _this7.Bookable = 1;
                            data[i].Bookable = 1;
                            _this7.curIndex = i;
                            _this7.mealId = data[i].mealId;
                            _this7.spareCol = data[i].spareCol1;
                            break;
                          } // 景  第三天可预订为


                          // 景  第三天可预订为
                          if (_this7.currDate != today && _this7.currDate != tomorrow) {
                            _this7.Bookable = 1;
                            data[i].Bookable = 1;
                            _this7.curIndex = 0;
                            _this7.mealId = data[0].mealId;
                            _this7.spareCol = data[0].spareCol1;
                            break;
                          }
                        }
                      } else if (data[i].spareCol7 == 0) {
                        //未开启当日不可定，则走正常判断时间流程
                        // operate：是否允许订餐  0 不允许 1 允许
                        //判断之前是否已有可预定餐别 0：没有 1：有
                        _this7.Bookable = data[i].operate;
                        data[i].Bookable = data[i].operate;

                        if (_this7.Bookable == 1) {
                          _this7.isfirst = 1;
                          _this7.curIndex = i;
                          _this7.mealId = data[i].mealId;
                          _this7.spareCol = data[i].spareCol1; // 景  只要是其他日期的餐别都是可以订的

                          // 景  只要是其他日期的餐别都是可以订的
                          break;
                        }
                      }
                    }

                    _this7.getFoodList(_this7.currDate, _this7.mySearch, _this7.mealId, _this7.merchantId, _this7.placeId);
                  }
                }).catch(function () {
                  _this7.$utils.Tools.httpError();
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * @function获取当前日期下的菜品清单
     *      wzx
     *   2019.05.05
     **/
    getFoodList: function getFoodList(date, foodName, mealId, merchantId, placeId) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.goods = [];
                _this8.xi = 0;
                _this8.xis = false;

                _this8.$utils.Tools.loadShow();

                _context5.next = 6;
                return _this8.$api.Meal.getFoodList({
                  date: date,
                  foodName: foodName,
                  mealId: mealId,
                  merchantId: merchantId,
                  placeId: placeId
                }).then(function (response) {
                  _this8.$utils.Tools.loadHide();

                  var code = response.code,
                      msg = response.msg,
                      data = response.data;

                  if (+code !== _this8.$code.success) {
                    _this8.$utils.Tools.toastShow(msg);
                  } else {
                    _this8.goods = [];

                    if (data.menuList.length > 0 && data.typeList.length > 0) {
                      _this8.emptyShow = false;
                      var jh = '';

                      var _iterator3 = _createForOfIteratorHelper(data.typeList),
                          _step3;

                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          var type = _step3.value;

                          // 将餐盒放在最下边
                          if (type.typeName == '餐盒') {
                            jh = {
                              typeCode: type.typeCode,
                              typeName: type.typeName,
                              meals: []
                            };
                          } else {
                            _this8.goods.push({
                              typeCode: type.typeCode,
                              typeName: type.typeName,
                              meals: []
                            });
                          }
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }

                      if (jh != '') {
                        _this8.goods.push(jh);
                      }

                      if (_this8.goods.length > 0) {
                        var _iterator4 = _createForOfIteratorHelper(_this8.goods),
                            _step4;

                        try {
                          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                            var item = _step4.value;

                            var _iterator6 = _createForOfIteratorHelper(data.menuList),
                                _step6;

                            try {
                              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                                var food = _step6.value;

                                if (food.foodType === item.typeCode) {
                                  item.meals.push({
                                    foodId: food.foodId,
                                    foodName: food.foodName,
                                    foodNum: food.foodNum,
                                    foodUse: food.foodUse,
                                    foodPhoto: food.foodPhoto,
                                    foodPrice: food.foodPrice,
                                    foodType: food.foodType,
                                    mealId: food.mealId,
                                    mealName: food.mealName,
                                    merchantId: food.merchantId,
                                    operate: food.operate,
                                    orderEnd: food.orderEnd,
                                    placeId: food.placeId,
                                    // spareCol1:fond.spareCol1
                                    spareCol1: food.spareCol1,
                                    spareCol2: food.spareCol2,
                                    spareCol3: food.spareCol3
                                  });
                                }
                              }
                            } catch (err) {
                              _iterator6.e(err);
                            } finally {
                              _iterator6.f();
                            }
                          }
                        } catch (err) {
                          _iterator4.e(err);
                        } finally {
                          _iterator4.f();
                        }

                        _this8.goods.forEach(function (items) {
                          items.meals.forEach(function (mealsItems) {
                            if (mealsItems.spareCol2) {
                              mealsItems.spareCol2 = mealsItems.spareCol2.split(',');
                            }

                            if (mealsItems.spareCol3) {
                              mealsItems.spareCol3 = mealsItems.spareCol3.split(',');
                            }
                          });
                        });

                        _this8.mealList = _this8.$store.getters.getterFoodList;
                        var totalPrice = 0;
                        _this8.totalNum = 0;
                        _this8.meals = [];

                        var _iterator5 = _createForOfIteratorHelper(_this8.mealList),
                            _step5;

                        try {
                          var _loop = function _loop() {
                            var item = _step5.value;

                            var _iterator7 = _createForOfIteratorHelper(data.menuList),
                                _step7;

                            try {
                              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                                var temp = _step7.value;

                                if (temp.mealId === item.mealId && temp.foodId === item.foodId) {
                                  item.foodOrder = Math.min(item.foodOrder, temp.foodNum - temp.foodUse);
                                  break;
                                }
                              }
                            } catch (err) {
                              _iterator7.e(err);
                            } finally {
                              _iterator7.f();
                            }

                            _this8.meals.push({
                              mealId: item.mealId,
                              mealName: item.mealName,
                              orderEnd: item.orderEnd,
                              spareCol1: item.spareCol1
                            });

                            var hash = {};
                            /*es6数组去重*/

                            /*es6数组去重*/
                            var newArr = _this8.meals.reduceRight(function (item, next) {
                              hash[next.mealId] ? '' : hash[next.mealId] = true && item.push(next);
                              return item;
                            }, []);

                            _this8.meals = newArr.sort(_this8.compare('mealId'));
                            totalPrice += parseFloat((item.foodPrice * item.foodOrder).toFixed(2));
                            _this8.totalNum += item.foodOrder;
                          };

                          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                            _loop();
                          }
                        } catch (err) {
                          _iterator5.e(err);
                        } finally {
                          _iterator5.f();
                        }

                        _this8.totalPrice = Math.round(totalPrice * 100) / 100;

                        _this8.$nextTick(function () {
                          _this8._calculateHeight();
                        });
                      }
                    } else {
                      _this8.emptyShow = true;
                    }
                  }
                }).catch(function () {
                  _this8.$utils.Tools.httpError();
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * @function获取订餐说明弹窗
     *      wzx
     *   2019.05.05
     **/
    showExplain: function showExplain() {
      var _this9 = this;

      // this.alertFlag = true;
      this.$utils.Tools.loadShow();
      this.$api.Meal.getExplain(this.placeId).then(function (response) {
        _this9.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this9.$code.success) {
          Toast(msg);
        } else {
          if (data == null || data == '') {
            Toast('暂无相关说明');
          }

          _this9.remark = data;
          _this9.img = data.spareCol2;
          var img = "<img style='width:100%'  src=".concat(data.spareCol2, ">");
          var Dsrc;

          if (data.spareCol2) {
            Dsrc = data.dineShow + '\n \n \n' + img;
          } else {
            Dsrc = data.dineShow + '\n \n \n';
          }

          Dialog.alert({
            title: '订餐说明',
            message: Dsrc,
            messageAlign: 'left'
          }).then(function () {// on close
          });
        }
      }).catch(function () {
        _this9.$utils.Tools.httpError();
      });
    },

    /**
     * @function点击去结算
     *      wzx
     *   2019.05.09
     **/
    goPay: function goPay() {
      // let mealList = JSON.stringify(this.mealList);
      // const tableware = this.mealList.filter((meal) => meal.foodName === '餐具')
      // if (tableware.length === 0) {
      //   Toast('请选择餐具！')
      // } else {
      this.$store.dispatch('actionFoodList', this.mealList);
      this.$router.push({
        path: '/OrderPay',
        query: {
          orderDate: this.currDate,
          placeId: this.placeId,
          cancelFlag: this.cancelFlag,
          spareCol: this.spareCol,
          placeName: this.placeName,
          windowName: this.windowName
        }
      }); // }
    },

    /**
     * @function查看订单记录
     *      wzx
     *   2019.05.09
     **/
    historyClick: function historyClick() {
      this.$router.push('/OrderRecord');
    },
    //获取该餐厅的窗口列表
    getWindowsList: function getWindowsList() {
      var _this10 = this;

      this.$api.AcDep.selectListByEntity({
        depDefine: 1,
        depParent: this.placeId
      }).then(function (response) {
        _this10.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this10.$code.success) {
          Toast(msg);
        } else {
          if (data && data.length > 0) {
            _this10.windowList = [[]];

            for (var i = 0; i < data.length; i++) {
              if (i === 0) {
                _this10.merchantId = data[0].depSerial;
                _this10.merchantName = data[0].depName;
                _this10.windowName = data[0].depName;
                _this10.tempMerchantId = [data[0].depSerial + ''];
              }

              _this10.windowList[0].push({
                name: data[i].depName,
                value: data[i].depSerial + ''
              });
            }
          }
        }
      }).catch(function () {
        _this10.$utils.Tools.httpError();
      });
    },
    // 改变订餐窗口
    windowChange: function windowChange(value) {
      var windowLists = this.windowList[0];

      for (var i = 0; i < windowLists.length; i++) {
        if (windowLists[i].value == value[0]) {
          this.windowName = windowLists[i].name;
        }
      }

      this.emptyClick();
      this.merchantId = value[0];
      this.getMealTypeList(this.currDate, this.merchantId, this.placeId);
    }
  },
  created: function created() {
    var _this11 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this11.placeId = _this11.$route.query.placeId;
              _this11.cancelFlag = _this11.$route.query.cancelFlag;
              _this11.placeName = _this11.$route.query.placeName;
              _context6.next = 5;
              return _this11.getSysDate();

            case 5:
              _context6.next = 7;
              return _this11.showExplain();

            case 7:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  mounted: function mounted() {
    var _this12 = this;

    this.dheight = document.body.clientHeight;
    this.$nextTick(function () {
      document.querySelector('.meal-ordering').style.height = _this12.dheight + 'px';

      _this12._initScroll(); //页面渲染完毕，初始化better-scroll组件

    });
  },
  updated: function updated() {
    var foodList = this.$refs.foodsWrapper.getElementsByClassName('food-list-hook');

    if (foodList[foodList.length - 1]) {
      var foodHeight = foodList[foodList.length - 1].clientHeight;
      var outerHeight = this.$refs.foodsWrapper.clientHeight;

      if (foodHeight < outerHeight) {
        foodList[foodList.length - 1].style.height = outerHeight + 'px';
      }
    }
  }
};